// src/encounter/services/use-education-levels.ts
// GET /api/Master/Education → the master education-level code list ({code, display, system}; SNOMED).
// Flutter: getEducationList (common_data_source_impl.dart:1546), feeds the Education picker. Master
// data — effectively static, so cached indefinitely and fetched lazily (only when the dialog opens).
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { EducationLevel } from '@/encounter/lib/to-education-request';

export function useEducationLevels(enabled: boolean) {
  return useQuery<EducationLevel[]>({
    queryKey: ['education-levels'],
    enabled,
    staleTime: Infinity,
    queryFn: ({ signal }) => get<EducationLevel[]>('/api/Master/Education', { signal }),
  });
}
